require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-use-the-twitch-json-api.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-use-the-twitch-json-api");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-use-the-twitch-json-api!./.cache/json/coding-interview-prep-take-home-projects-use-the-twitch-json-api.json
// module id = 1945
// module chunks = 231608221292675